import { AbiRegistry, SmartContract, Address } from '@multiversx/sdk-core/out';
import contractConfig from '../../config.json';
import rawVestaMinterAbiJson from '../../assets/abi/raw-vesta-minter.abi.json';
import lpVstFarm from '../../assets/abi/vesta-lp-farm.abi.json';

const getSmartContract = (scAddress: string, abiJson: any) => {
  const abiRegistry = AbiRegistry.create(abiJson);
  return new SmartContract({
    address: new Address(scAddress),
    abi: abiRegistry
  });
};

export const getRawVestaMinterSc = () =>
  getSmartContract(
    contractConfig.contractConfiguration.rawVestaMinter.mainnet.address,
    rawVestaMinterAbiJson
  );

export const getFarmSc = (farmAddress: string) =>
  getSmartContract(farmAddress, lpVstFarm);
